import VehicleCodeModal from './VehicleCodeModal'
import vehicleCodeModalContainer from './vehicleCodeModalContainer'

export default vehicleCodeModalContainer(VehicleCodeModal)
